module.exports = __webpack_public_path__ + "img/maroof.301d0228.png";